<style lang="scss">
#app {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
}
</style>

<template>
  <div id="app">
    <AppHeader/>
    <AppContent/>
    <AppFooter/>
  </div>
</template>

<script>
import AppContent from './AppContent';
import AppFooter from './AppFooter';
import AppHeader from './AppHeader';

export default {
  name: 'App',
  components: {
    AppHeader,
    AppContent,
    AppFooter,
  },
  mounted() {
    this.$ga.page('/');
  },
};
</script>
